import React from 'react';
import PropTypes from 'prop-types';
import { StyledAccordionActions } from './style';

/**
 * Componente AccordionActions
 *
 * @param {React.Props} children - Debería ser un componente AccordionActionsItem
 */

const AccordionActions = ({ className, children }) => (
  <StyledAccordionActions className={className}>
    {children}
  </StyledAccordionActions>
);

AccordionActions.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node
};

AccordionActions.defaultProps = {
  className: undefined,
  children: undefined
};

export default AccordionActions;
